import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import ForEmployers from "@/pages/ForEmployers";
import ForRecruiters from "@/pages/ForRecruiters";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import RegisterBusiness from "@/pages/RegisterBusiness";
import VerifyEmail from "@/pages/VerifyEmail";
import Plans from "@/pages/Plans";
import Pricing from "@/pages/Pricing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CareerFit from "@/pages/CareerFit";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Legal from "@/pages/Legal";
import HelpCenter from "@/pages/HelpCenter";
import UserRules from "@/pages/UserRules";
import AiMatches from "@/pages/AiMatches";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Profile from "@/pages/Profile";
import Documents from "@/pages/Documents";
import Applications from "@/pages/Applications";
import SavedJobs from "@/pages/SavedJobs";
import SavedSearches from "@/pages/SavedSearches";
import Interview from "@/pages/Interview";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import EmployerWorkspace from "@/pages/EmployerWorkspace";
import RecruiterWorkspace from "@/pages/RecruiterWorkspace";
import RecruiterClients from "@/pages/RecruiterClients";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/for-employers" element={<ForEmployers />} />
      <Route path="/for-recruiters" element={<ForRecruiters />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register-business" element={<RegisterBusiness />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/help" element={<HelpCenter />} />
      <Route path="/rules" element={<UserRules />} />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/career-fit" element={<CareerFit />} />
        <Route path="/matches" element={<AiMatches />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/:id" element={<JobDetail />} />
        <Route path="/saved" element={<SavedJobs />} />
        <Route path="/searches" element={<SavedSearches />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/employer" element={<EmployerWorkspace />} />
        <Route path="/recruiter" element={<RecruiterWorkspace />} />
        <Route path="/recruiter/clients" element={<RecruiterClients />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
